import { connect } from 'react-redux';
import AiStreamingAssistantSidePanel from '../../components/AiStreamingAssistant/AiStreamingAssistantSidePanel/aiStreamingAssistantSidePanel';

export default connect((state) => {
  let sData = state.aiStreamingAssistant;

  return {
    sData,
    showSidePanel: sData.get('showSidePanel'),
  };
})(AiStreamingAssistantSidePanel);
